import React from "react";

export default ({url, title, variant_title, properties, quantity = 0, compareAtPriceString, priceString, imageSrc, imagAlt, imageSrcSet, actions, busy, includedItems = [], note}) => {

  const visibleProperties = properties ? Object.keys(properties).map((key)=> ({key, value: properties[key]})).filter((node)=> !node.key.startsWith("_")) : [];

  const propertyMarkup = visibleProperties.length ? <div class="pt-0.5 border-t v-stack gap-0.5">
    { visibleProperties.map(({key, value})=>{
        if(key.startsWith("_")) return null;
        return <p className="text-sm text-subdued">{key}: {value}</p>
      })
    }</div> : null;

  return <><line-item class="line-item" data-busy={busy}>
      <div className="line-item__media-wrapper">
        <img src={imageSrc} alt={imagAlt} srcSet="" width="2000" height="1333" loading="lazy" sizes="(max-width: 740px) 80px, 96px" className="line-item__media rounded-xs"/>
        <pill-loader class="pill-loader" aria-busy={busy ? "true" : "false"}></pill-loader>
      </div>
      <div className="line-item__info">
        <div className="v-stack gap-0.5">
          <a href={url} className="bold">
            <span className="reversed-link hover:show">{title}</span>
          </a>
          <div className="h-stack gap-1 items-center">
            <price-list class="price-list">
              { compareAtPriceString ?
              <compare-at-price class="text-subdued line-through">
                <span class="sr-only">Regular price</span> {compareAtPriceString}
              </compare-at-price>
              : null }
              <sale-price>
                <span className="sr-only">Sale price</span> {priceString}
              </sale-price>
            </price-list>
          </div>
          { variant_title ? <p className="text-sm text-subdued">{variant_title}</p> : null}
          {propertyMarkup}
        </div>
        { actions ? <div className="text-sm text-subdued sm:hidden">
          { actions }
        </div> : null }
        {includedItems?.items?.length > 0 &&
        <div className="line-item__included">
            <p className="text-sm text-subdued mb-1">{includedItems?.title || window.themeVariables?.strings?.includedAccessories || 'Accessory pack included'}</p>
            <div className="h-stack gap-1">
              {includedItems?.items?.map((node)=>{
                return <div className="line-item__included-item">
                  <img src={node.image.url} alt={node.image.altText} width="50" height="50" loading="lazy" className="line-item__included-item-media rounded-xs"/>
                </div>
              })}
            </div>
        </div>}
      </div>
      { actions ? <div className="line-item__actions text-subdued hidden sm:block">
        { actions }
      </div> : null }
    </line-item>
    {note ?
      <div class={`line-item__note line-item__note--${note.level}`} dangerouslySetInnerHTML={{
        __html: note.content,
        }}/>
        : null}
    </>
}
